import PageLayout from "@/components/ui/page-layout";
import SubscriptionsTable from "@/features/subscriptions/components/SubscriptionsTable";
import NewSubscriptionAction from "@/features/subscriptions/components/NewSubscriptionAction";
import PlansTable from "@/features/plans/components/PlansTable";

export default function PlansRoute() {
    const breadcrumbs = [
        { label: 'Plans', href: '/plans' },
    ]
    return (
        <PageLayout
            title='Plans'
            subtitle='Manage plans'
            action={<NewSubscriptionAction />}
            breadcrumbs={breadcrumbs}
        >
            <PlansTable />
        </PageLayout>
    )
}